export const NEWSBOARD_POST_STATUS_ONLINE = 'online'

export const NEWSBOARD_POST_STATUS_PLANNED = 'planned'

export const NEWSBOARD_POST_STATUS_OFFLINE = 'offline'

export const NEWSBOARD_POST_STATUS_BLOCKED = 'blocked'

export const NEWSBOARD_STATUS = {
  [NEWSBOARD_POST_STATUS_BLOCKED]: {
    text: 'Newsboard.StatusBlockedKey',
    textColor: 'var(--color-error)',
  },
  [NEWSBOARD_POST_STATUS_OFFLINE]: {
    text: 'Newsboard.StatusOfflineKey',
    textColor: 'var(--color-error)',
  },
  [NEWSBOARD_POST_STATUS_ONLINE]: {
    text: 'Newsboard.StatusOnlineKey',
    textColor: 'var(--color-success)',
  },
  [NEWSBOARD_POST_STATUS_PLANNED]: {
    text: 'Newsboard.StatusPlannedKey',
    textColor: 'var(--color-info)',
  },
}
